module.exports = __webpack_public_path__ + "static/media/notice-img-05@2x.7d63c023.png";